<template>
    <div class="SuggestedVideos">
        <div class="first-part-wrapper">
            <div class="image-container">
                <div class="image-wrapper">
                    <svgicon icon="videos_icon" :original="true" class="icon" />
                </div>
                <div class="title-refresh-wrapper-mobile">
                    <div class="title-wrapper-mobile">
                        <p class="mobile-title">{{ $t('title') }}</p>
                        <p>{{ $t('refresh') }}</p>
                    </div>
                    <div class="refresh-wrapper-mobile">
                        <button @click="getRandomVideos()">
                            <img src="@/assets/images/refresh.png" alt="refresh" />
                        </button>
                    </div>
                </div>
            </div>

            <div class="suggested-videos-wrapper">
                <div class="title-refresh-wrapper">
                    <div class="title-wrapper">
                        <p>{{ $t('title') }}</p>
                    </div>
                    <div class="refresh-wrapper">
                        <button @click="getRandomVideos()">
                            <img src="@/assets/images/refresh.png" alt="refresh" />
                        </button>
                    </div>
                </div>
                <template v-if="loading">
                    <Skeleton v-for="n of suggestedVideosCount" :key="n" />
                </template>
                <template v-else>
                    <SuggestedVideo
                        v-for="video in randomVideos"
                        :id="video.id"
                        :key="video.id"
                        :lifeskill-id="lifeskillId"
                    />
                </template>
            </div>
        </div>
        <div class="second-part-wrapper">
            <p>{{ braindatesForNextLifekey }} {{ $t('footerText') }}</p>
        </div>
    </div>
</template>

<translations>
    title: Suggested videos
    title_no: Foreslåtte videoer
    refresh: Refresh videos
    refresh_no: Vis nye videoer
    footerText: 'braindates to next life key'
    footerText_no: 'hjernedates til neste livsnøkkel'
</translations>

<script>
import SuggestedVideo from './SuggestedVideo';
import Skeleton from './Skeleton';
import { mapGetters, mapActions } from 'vuex';

export default {
    components: {
        SuggestedVideo,
        Skeleton
    },
    props: {
        lifeskillId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            suggestedVideosCount: 3,
            randomVideos: [],
            loading: false
        };
    },

    computed: {
        ...mapGetters({
            getAcquiredVideoBraindates: 'moduleApp/getVideoBraindatesMap',
            getLifeskillStats: 'moduleApp/getLifeskillStats'
        }),

        braindatesForNextLifekey() {
            let braindatesToAquireLifekey = 25;
            const acquiredVideoBraindates = this.getAcquiredVideoBraindates[this.lifeskillId]
                ? this.getAcquiredVideoBraindates[this.lifeskillId].length
                : 0;
            const lifeskillStats = this.getLifeskillStats(this.lifeskillId);
            const { acquiredVideoLifekeys, totalVideoLifekeys } = lifeskillStats;

            if (acquiredVideoLifekeys === totalVideoLifekeys) {
                return;
            }

            if (braindatesToAquireLifekey <= acquiredVideoBraindates) {
                braindatesToAquireLifekey += 25;
            }

            return braindatesToAquireLifekey - acquiredVideoBraindates;
        },

        lifeskillVideos() {
            return Object.values(this.$store.state.moduleApp.videos).filter(
                video =>
                    video.lifeskillId === this.lifeskillId || video.lifeskillIds.some(id => id === this.lifeskillId)
            );
        }
    },

    async mounted() {
        if (!this.$store.state.moduleApp.videos.length) {
            this.loading = true;
            await this.loadVideos();
        }

        this.getRandomVideos();

        this.loading = false;
    },

    methods: {
        ...mapActions({ loadVideos: 'moduleApp/loadAllVideos' }),
        getRandomVideos() {
            this.randomVideos = []; // clear random videos before pushing new

            const randomVideoIndexes = [];

            while (randomVideoIndexes.length < this.suggestedVideosCount) {
                const randomVideoIndex = Math.floor(Math.random() * this.lifeskillVideos.length);

                if (!randomVideoIndexes.includes(randomVideoIndex)) {
                    randomVideoIndexes.push(randomVideoIndex);
                }
            }

            randomVideoIndexes.forEach(i => {
                this.randomVideos.push(this.lifeskillVideos[i]);
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.SuggestedVideos {
    display: flex;
    position: relative;
    flex-direction: column;
    background: #fdfdfd;
    box-shadow: 0px 2px 23px 3px rgba(79, 79, 79, 0.1);
    border-radius: 4px;
    padding: 1.2em 1.4em 4.5em;
    width: 100%;
    position: relative;
    justify-content: space-between;
    margin: 1em 0;
    @media (max-width: 530px) {
        padding: 1.2em 8px 6em 8px;
    }

    .image-container {
        @media (max-width: 530px) {
            display: flex;
        }
        .image-wrapper {
            min-width: 97px;
            min-height: 97px;
            max-width: 97px;
            max-height: 97px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 10.0799px;
            @media (max-width: 530px) {
                min-width: 68px;
                min-height: 68px;
                max-width: 68px;
                max-height: 68px;
            }
            .icon {
                width: 100%;
                height: 100%;
            }
        }
        .title-refresh-wrapper-mobile {
            display: none;
            justify-content: space-between;
            @media (max-width: 530px) {
                display: flex;
                align-items: center;
                margin-left: 1em;
                width: 100%;
            }
            .title-wrapper-mobile {
                @media (max-width: 530px) {
                    padding-right: 1em;
                }
                h3 {
                    font-size: 16px;
                    font-weight: 500;
                    line-height: 26px;
                    margin: 0;
                    color: #151515;
                }
                p {
                    font-size: 16px;
                    line-height: 22px;
                    color: #727272;
                    margin: 0;
                    &:nth-child(2) {
                        @media (max-width: 530px) {
                            font-size: 14px;
                        }
                    }
                }
                .mobile-title {
                    color: #151515;
                }
            }
            .refresh-wrapper-mobile {
                display: flex;
                align-items: center;
                button {
                    background-color: white;
                    border: none;
                    outline: none;
                    cursor: pointer;
                }
            }
        }
    }

    .first-part-wrapper {
        display: flex;
        width: 100%;
        @media (max-width: 530px) {
            flex-direction: column;
        }
        .suggested-videos-wrapper {
            margin-left: 1.2em;
            width: 100%;
            @media (max-width: 530px) {
                margin-top: 1em;
                margin-left: 0;
            }
            .title-refresh-wrapper {
                display: flex;
                justify-content: space-between;
                @media (max-width: 530px) {
                    display: none;
                }
                .title-wrapper {
                    p {
                        font-size: 16px;
                        line-height: 22px;
                        color: #727272;
                    }
                }
                .refresh-wrapper {
                    display: flex;
                    align-items: center;
                    button {
                        background-color: white;
                        border: none;
                        outline: none;
                        cursor: pointer;
                    }
                }
            }
        }
    }
    .second-part-wrapper {
        background: rgba(89, 131, 247, 0.1);
        border-radius: 4px;
        position: absolute;
        bottom: 6px;
        right: 10px;
        left: 10px;
        @media (max-width: 530px) {
            bottom: 1em;
        }
        p {
            text-align: center;
            color: #404040 80%;
            font-size: 16px;
            line-height: 22px;
        }
    }
}
</style>
